import { Link } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileFeatureStore } from '@lib/store/profile';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import type { UserWithPaymentInfo } from '@shared/api/rest/users';
import { ColorsEnum, Icon, Text } from '@shared/widgets';
import LockIcon from '@assets/icons/lock.svg';
import ExpandArrowIcon from '@assets/icons/expand-arrow.svg';
import ExpandInArrowIcon from '@assets/icons/expand-in-arrow.svg';

interface IUserItemHeadProps {
  user: UserWithPaymentInfo;
  setOpen?: () => void;
  open?: boolean;
}

export const UserItemHead = (props: IUserItemHeadProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const { t } = useTranslation();

  return (
    <div className='relative p-6 pb-8'>
      <Link to={profileFeatureStore.data?.userManagement.viewUserProfileDetails ? RoutePaths.user.onNavigate(props.user.id) : ''}>
        <div className='relative max-w-[calc(100%-30px)]'>
          <div className='flex shrink items-center'>
            <div className='relative mr-3 flex h-12 w-12 flex-none select-none items-center justify-center overflow-hidden rounded-full text-center'>
              <div className='relative z-[1] flex h-full w-full items-center justify-center rounded bg-primary'>
                <Text weight='medium' size='xl' color={PaletteUtils.getColor(ColorsEnum.Black, ColorsEnum.White)} uppercase>
                  {props.user.firstName[0]}
                </Text>
              </div>
              {props.user.locked && (
                <div className='absolute left-0 top-0 z-[3] flex h-full w-full items-center justify-center rounded bg-dark-wet-asphalt text-center'>
                  <Icon icon={<LockIcon width='24' height='24' />} color='red' />
                </div>
              )}
            </div>
            <div className={cn('flex-1 px-0 py-1', props.user.locked && 'opacity-50')}>
              <Text className='overflow-hidden text-ellipsis capitalize' size='xl'>
                {props.user.firstName} {props.user.lastName}
              </Text>
              <Text size='sm' color={ColorsEnum.Gray}>
                {t(`role.${props.user.userType.toLowerCase()}`)}
              </Text>
            </div>
          </div>
        </div>
      </Link>
      <div
        className='absolute right-6 top-6 flex cursor-pointer items-center justify-center p-0 text-center text-2xl text-slate dark:text-gray-white'
        onClick={props.setOpen}
      >
        <Icon icon={props.open ? <ExpandInArrowIcon /> : <ExpandArrowIcon />} />
      </div>
    </div>
  );
};
